import React, {useState,useEffect} from "react";
import { connect } from "react-redux";
import { stateSet } from "../../actions/commonAction";
import ReactPlayer from 'react-player'
// import {
//   Popup,
//   //Button,
// } from "semantic-ui-react";

import Modal from '../modalGr/Modal';

const VidModal = (props) => {
  
  const [playing, setPlaying] = useState(false);

  const timerfn =()=>{ 
    if(props.commons.timer ==='Yes'){
      setTimeout(() => {
        openModal();
      }, 5000);
    }
    }
    // @@@ to open video on first time visit only
    // handleLocalStorage=()=>{
    //   localStorage.setItem("alertRead", 'Yes');
    //    this.props.closeModal()
    //   //  window.location.reload(false)
    //  }
  // openPopup =()=>{
  //   if(localStorage.alertRead !=='Yes'){
  //   setTimeout(()=>this.props.openModal('AlertModal'),10000)
  // }
  // }
  useEffect(() => {
     timerfn() ;

    //Cleanup function to clear the timer when the component unmounts
    return () => {
      clearTimeout(timerfn);
    };
  }, []);

  const openModal = (timer) => {
    props.stateSet({timer:'No',vidModal:true,greetingPopup:true});
    // to stop scrolling of body content
  //  document.body.style.overflow = 'hidden';
    clearTimeout(timer);
    // window.scroll(0, 0);
  };
  const closeModal = () => {
    // to start scrolling of body content
    // document.body.style.overflow = 'auto';
    props.stateSet({vidModal:false});
    // stop playing of video in background
    setPlaying(false)
  };
  
  

  
  

  //*************** */
 

const vidPlay =() => {
  setPlaying(!playing)
  // to close the popup
  props.stateSet({greetingPopup:false});
}

  //*************** */
  return (
    <section className="">
      
        
      {props.commons.vidModal && (<div > 
      <Modal   hasCloseBtn={false} isOpen={props.commons.vidModal} onClose={closeModal} className={"modal-vid body"}>
      
      <div className="flex-center mt-20 button-placement">
          
      <button className="close-button-gr" 
      style={{fontSize:'20px'}}
      onClick={closeModal}>
        X
      </button>
      </div>
      
      <div style={{display:'flex',flexDirection:'column'}}>
      <div className='player-wrapper mt-mobile'>
            <ReactPlayer
            // Disable download button
  config={{ file: { attributes: { controlsList: 'nodownload' } } }}

  // Disable right click
  onContextMenu={e => e.preventDefault()}
  playing={playing}
  // playing={true}
            controls = {true}
            className='react-player'
            url= 'https://www.youtube.com/watch?v=rsJD28YDHyQ&autoplay=1&mute=1' 
            width='100%'
            height='90vh'
            />
            </div>
            {/* <div className="flex-center mt-20 button-placement">
          
      <button className="close-button-gr" 
      style={{fontSize:'20px'}}
      onClick={closeModal}>
        X
      </button>
      </div> */}
      {props.commons.greetingPopup && (<div > 
      <div   className="popup flex-center" >
       <div className="flex-center popup-card color-white bgColor-gradient"
       style={{margin:'auto',}}
       > 
       <div className="font-24B" style={{lineHeight:'30px'}} >Welcome <br/> To <br/>Gupta Realtors</div>
        <p className="font-20B">If you have any query, please don’t hesitate to contact us . We’re here to help you.</p>
        <div  className="tag-cloud color-white" style={{fontSize:'20px', color:'white'}}
        onClick={vidPlay}
        >Ok</div>
        </div>
    </div>
    </div>)}
            
    </div>
    </Modal>
    </div>
    )}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    state,
    commons:state.commons,
  };
};

// export default VidModal;
export default connect(
  mapStateToProps,
  {stateSet}
)(VidModal);